document.addEventListener('DOMContentLoaded', () => {
  const pdfButton = document.getElementById('pdfButton');
  if (pdfButton) {
    const loadingSpinner = pdfButton.querySelector('.loading__spinner');
    const spinnerCircle = loadingSpinner.querySelector('circle');
    if (spinnerCircle) {
      spinnerCircle.style.stroke = '#fff';
    }
    pdfButton.addEventListener('click', async (event) => {
      const recipeId = event.target.dataset.recipeId;
      if (recipeId) {
        showLoadingSpinner(loadingSpinner);
        const country =
          typeof Shopify != "undefined"
            ? Shopify?.country?.toLowerCase()
              ? Shopify.country?.toLowerCase()
              : "us"
            : "us";

        const language =
          typeof Shopify != "undefined"
            ? Shopify?.locale
              ? Shopify.locale
              : "en"
            : "en";

        let pdfStore = null;
        let pdfLanguage = null;

        const latinAmericanSpanishCountries = [
          "ar", "bo", "cl", "co", "cr", "cu", "ec", "sv", "gt", "hn", "ni", "pa", "py", "pe", "do", "uy", "ve"
        ];

        if (latinAmericanSpanishCountries.includes(country)) {
          pdfStore = "latam";
          pdfLanguage = "es";
        } else {
          switch (country) {
            case "us":
              pdfStore = "us";
              pdfLanguage = "en";
              break;
            case "mx":
              pdfStore = "mx";
              pdfLanguage = "es";
            case "ca":
              pdfStore = "ca";
              pdfLanguage = getCanadaLanguage(language);
              break;
            default:
              pdfStore = "us";
              pdfLanguage = "en";
          }
        }

        await fetchPdfUrl(recipeId, pdfStore, pdfLanguage);
        hideLoadingSpinner(loadingSpinner);
      } else {
        console.error('Recipe ID not found:', recipeId);
      }
    });
  } else {
    console.error('PDF button not found.');
  }
});

async function fetchPdfUrl(recipeId, pdfStore, pdfLanguage) {
  const url = `https://shopify-monin.gadget.app/recipe/generatepdf/${recipeId}?country=${pdfStore}&language=${pdfLanguage}`;
  const config = {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
    },
  };

  try {
    const res = await fetch(url, config);

    if (!res.ok) {
      throw new Error(`Failed to fetch pdf url: ${res.status}`);
    }

    const data = await res.json();

    if (data && data.recipePdfUrl) {
      window.open(data.recipePdfUrl, '_blank');
    }
  } catch (error) {
    console.error('Failed to fetch pdf url:', error);
    alert('Failed to fetch the PDF. Please try again later.');
  }
}

function getCanadaLanguage(language) {
  if (language === "fr" || language.startsWith("fr")) {
    return "fr";
  }
  return "en";
}

function showLoadingSpinner(loadingSpinner) {
  if (loadingSpinner) {
    loadingSpinner.classList.remove('hidden');
  }
}

function hideLoadingSpinner(loadingSpinner) {
  if (loadingSpinner) {
    loadingSpinner.classList.add('hidden');
  }
}
